import { supabase } from '../../lib/supabase';
import { edgeErrorMessage } from '../../shared/lib/edge-error';

export interface RequestInstituteArgs {
  name: string;
  slug: string;
  owner_email: string;
  owner_name: string;
  owner_phone: string;
  /** Phase 184. Omitted when no Turnstile key is configured. */
  turnstile_token?: string;
}

export interface RequestInstituteResult {
  institute_id: string;
  owner_user_id: string | null;
  status: 'pending';
  already_existed: boolean;
}

export async function requestInstitute(
  args: RequestInstituteArgs,
): Promise<RequestInstituteResult> {
  const { data, error } = await supabase.functions.invoke<RequestInstituteResult>(
    'request-institute',
    { body: args },
  );
  if (error !== null) {
    // The throttle and the captcha both answer with a specific sentence, and
    // supabase-js hides it behind "non-2xx status code" unless it is read off
    // the response.
    throw new Error(await edgeErrorMessage(error));
  }
  if (data === null) {
    throw new Error('request-institute returned no body');
  }
  return data;
}
